import { createTheme } from '@mui/material/styles';

// Define color palette
const colors = {
  primary: {
    main: '#0a7ca0',
    light: '#4aafce',
    dark: '#005173',
    contrastText: '#ffffff',
  },
  secondary: {
    main: '#00b7c7',
    light: '#62e9f9',
    dark: '#008796',
    contrastText: '#ffffff',
  },
  background: {
    default: '#f5f8fa',
    paper: '#ffffff',
  },
  text: {
    primary: '#212121',
    secondary: '#546e7a',
  },
};

// Create theme with typography and spacing config
const theme = createTheme({
  palette: {
    primary: colors.primary,
    secondary: colors.secondary,
    background: colors.background,
    text: colors.text,
  },
  typography: {
    fontFamily: '"Sora", "Helvetica", "Arial", sans-serif',
    h1: {
      fontSize: '2.5rem',
      fontWeight: 500,
    },
    h2: {
      fontSize: '2rem',
      fontWeight: 500,
    },
    h3: {
      fontSize: '1.75rem',
      fontWeight: 500,
    },
    h4: {
      fontSize: '1.5rem',
      fontWeight: 500,
    },
    body1: {
      fontSize: '1rem',
    },
    button: {
      textTransform: 'none',
    },
  },
  spacing: 8, // 8px base spacing unit
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          // Ensure minimum touch target size for mobile
          minHeight: 44,
          minWidth: 44,
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          // Ensure minimum touch target size for mobile accessibility
          minHeight: 44,
          minWidth: 44,
        },
        sizeSmall: {
          // Override small size to still meet touch targets
          minHeight: 44,
          minWidth: 44,
          fontSize: '1.2rem',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
        },
      },
    },
  },
});

export default theme; 